export const OVERRIDE_LOGOS = ['HJ', 'SL', 'TI', 'XN', 'MP', '4U'];